import { render, staticRenderFns } from "./the-settings.vue?vue&type=template&id=4dde5277"
import script from "./the-settings.vue?vue&type=script&lang=js"
export * from "./the-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports